import React from 'react';

const StopWorkingIcon = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#F9F4FD" />
      <g clipPath="url(#clip0_1317_26776)">
        <path
          d="M11.9997 5.14307C10.6435 5.14307 9.31775 5.54523 8.1901 6.2987C7.06245 7.05218 6.18355 8.12312 5.66455 9.37609C5.14555 10.6291 5.00975 12.0078 5.27434 13.338C5.53892 14.6681 6.192 15.89 7.15099 16.8489C8.10998 17.8079 9.33181 18.461 10.662 18.7256C11.9921 18.9902 13.3709 18.8544 14.6238 18.3354C15.8768 17.8164 16.9478 16.9375 17.7012 15.8098C18.4547 14.6822 18.8569 13.3564 18.8569 12.0002C18.8549 10.1822 18.1318 8.43919 16.8463 7.15365C15.5607 5.86811 13.8177 5.14503 11.9997 5.14307V5.14307ZM11.9997 17.7145C10.8695 17.7145 9.76475 17.3794 8.82504 16.7515C7.88533 16.1236 7.15291 15.2311 6.72041 14.187C6.28791 13.1428 6.17475 11.9939 6.39524 10.8854C6.61572 9.77694 7.15996 8.75876 7.95911 7.9596C8.75827 7.16044 9.77646 6.61621 10.8849 6.39572C11.9934 6.17523 13.1423 6.2884 14.1865 6.7209C15.2306 7.1534 16.1231 7.88581 16.751 8.82552C17.3789 9.76523 17.714 10.87 17.714 12.0002C17.7123 13.5152 17.1098 14.9677 16.0385 16.039C14.9672 17.1103 13.5147 17.7128 11.9997 17.7145ZM11.9997 9.14307C11.5958 9.1423 11.2047 9.28451 10.8956 9.54449C10.5865 9.80448 10.3794 10.1655 10.3109 10.5635C10.2425 10.9616 10.3171 11.371 10.5216 11.7193C10.7262 12.0676 11.0473 12.3323 11.4283 12.4665V14.2859C11.4283 14.4375 11.4885 14.5828 11.5957 14.69C11.7028 14.7971 11.8482 14.8574 11.9997 14.8574C12.1513 14.8574 12.2966 14.7971 12.4038 14.69C12.5109 14.5828 12.5712 14.4375 12.5712 14.2859V12.4665C12.9521 12.3323 13.2733 12.0676 13.4778 11.7193C13.6823 11.371 13.757 10.9616 13.6885 10.5635C13.6201 10.1655 13.413 9.80448 13.1039 9.54449C12.7948 9.28451 12.4036 9.1423 11.9997 9.14307ZM11.9997 11.4288C11.8867 11.4288 11.7762 11.3953 11.6823 11.3325C11.5883 11.2697 11.515 11.1804 11.4718 11.076C11.4285 10.9716 11.4172 10.8567 11.4393 10.7459C11.4613 10.635 11.5157 10.5332 11.5957 10.4533C11.6756 10.3734 11.7774 10.319 11.8882 10.2969C11.9991 10.2749 12.114 10.2862 12.2184 10.3294C12.3228 10.3727 12.4121 10.4459 12.4748 10.5399C12.5376 10.6339 12.5712 10.7443 12.5712 10.8574C12.5712 11.0089 12.5109 11.1542 12.4038 11.2614C12.2966 11.3686 12.1513 11.4288 11.9997 11.4288Z"
          fill="#6D6D6D"
        />
      </g>
      <defs>
        <clipPath id="clip0_1317_26776">
          <rect
            width="13.7143"
            height="13.7143"
            fill="white"
            transform="translate(5.14258 5.14307)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StopWorkingIcon;
